// extracted by mini-css-extract-plugin
export var appearAnimation = "Footer-module--appearAnimation--96e2c";
export var buttonsWrapper = "Footer-module--buttonsWrapper--b0d96";
export var fadeInAnimation = "Footer-module--fadeInAnimation--c505a";